import React from "react";
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { Link } from "react-router-dom";

const Breadcrumbs = ({ currentItem = 'league', sportId, leagueId }) => {
    let leagueBrc = '';
    let matchBrc = '';
    let matchOddBrc = '';

    if (currentItem === 'league') {
        leagueBrc = <BreadcrumbItem active>LEAGUE</BreadcrumbItem>;
    } else if (sportId) {
        leagueBrc = <BreadcrumbItem><Link to={`/sports/${sportId}`}>LEAGUE</Link></BreadcrumbItem>;
    }

    if (currentItem === 'match') {
        matchBrc = <BreadcrumbItem active>MATCH</BreadcrumbItem>;
    } else if (leagueId) {
        matchBrc = <BreadcrumbItem><Link to={`/leagues/${leagueId}/sport/${sportId}`}>MATCH</Link></BreadcrumbItem>;
    }

    if (currentItem === 'matchOdd') {
        matchOddBrc = <BreadcrumbItem active>Odds</BreadcrumbItem>;
    }

    return (
        <Breadcrumb className="tp-breadcrumbs">
            {leagueBrc}
            {matchBrc}
            {matchOddBrc}
        </Breadcrumb>
    );
};

export default Breadcrumbs;
